module.exports = __webpack_public_path__ + "1416ab6009ad93f86e9cfc23a54e0c40.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/italy.png
 ** module id = 667
 ** module chunks = 0
 **/